import { render } from "./logistic.vue?vue&type=template&id=f2eae230&scoped=true"
import script from "./logistic.vue?vue&type=script&lang=js"
export * from "./logistic.vue?vue&type=script&lang=js"

import "./logistic.vue?vue&type=style&index=0&id=f2eae230&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2eae230"]])

export default __exports__